const { store$ } = require("@redux/store");
const { map, distinctUntilChanged, filter } = require("rxjs");

const subMenuAccountList = document.querySelector('[data-sub-menu-account-list]');
const subMenuAccountContainer = document.querySelector('[data-sub-menu-account-container]');
const linkSelector = (state) => state?.userProfile?.links;
const invalidValuesFilter = (value) => !!value && value.length > 0;
const drawMenu = (links) => { 
    links.forEach(link => {
        const li = document.createElement('li');
        li.classList.add('padding--link');
        li.dataset.component = link?.component;
        const anchor = document.createElement('a');
        anchor.href = link?.url;
        anchor.innerText = link.text;
        if (link.ShouldOpenNewTab) {
          anchor.target = '_blank';
          anchor.rel = 'noopener noreferrer';
        }
        anchor.dataset.qa = link?.component;
        li.appendChild(anchor);
        subMenuAccountList.appendChild(li);
    });
    subMenuAccountContainer.removeAttribute('hidden')
 };

store$.pipe(
  map(linkSelector),
  distinctUntilChanged(),
  filter(invalidValuesFilter)
).subscribe(drawMenu);